/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRACRAPagedResponse
 */
export interface CRACRAPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRACRAPagedResponse
     */
    total: number;
    /**
     * 
     * @type {Array<any>}
     * @memberof CRACRAPagedResponse
     */
    results: Array<any>;
    /**
     * 
     * @type {number}
     * @memberof CRACRAPagedResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof CRACRAPagedResponse
     */
    page_size: number;
}

/**
 * Check if a given object implements the CRACRAPagedResponse interface.
 */
export function instanceOfCRACRAPagedResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;

    return isInstance;
}

export function CRACRAPagedResponseFromJSON(json: any): CRACRAPagedResponse {
    return CRACRAPagedResponseFromJSONTyped(json, false);
}

export function CRACRAPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRACRAPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'results': json['results'],
        'page': json['page'],
        'page_size': json['page_size'],
    };
}

export function CRACRAPagedResponseToJSON(value?: CRACRAPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': value.results,
        'page': value.page,
        'page_size': value.page_size,
    };
}

